import React from 'react';
import NavBar from '../nav/NavBar.tsx';
import './HomePage.css';

function HomePage() {
  return (
    <>
      <NavBar></NavBar>
      <div className={'overlay'}>
        <div className={'home-top'}>
          <div className={'home-main-text'}>
            <h2 className={'welcome-text'}>Welcome!</h2>
            <h3 className={'welcome-sub-text-1'}>
              More info coming soon...
            </h3>
            <h3 className={'welcome-sub-text-1'}>
              Try Now!
              {/* It can be one, it can me some. It can be many, it could be plenty.
              <br />
              No matter the task with whatever you ask, No matter if it be
              <br />
              needlessly vast, We will persist to make the future, your task,
              <br />
              just a thing of the past. Master your craft, master it fast
              <br />
              before, it is gone. */}
              {/* <br /> */}
            </h3>
          </div>
        </div>
      </div>
      <div className={'home-buttons-container'}>
        <a className={'button-blue'} href="lab/login">
          Log In
        </a>
        <a className={'button-white'} href="lab/sign-up">
          Sign Up!
          {/* Check out the community */}
          <br />
        </a>
      </div>
      {/* <div className={'overlay-middle'}></div> */}
    </>
  );
}

export default HomePage;
